import { FiDownload } from "react-icons/fi";
import { RxEnterFullScreen, RxExitFullScreen } from "react-icons/rx";
import styled from "styled-components";

interface OptionButtonProps{
  url: string;
  onFullscreenToggle?: () => void;
  isFullscreen?: boolean;
  toggleDownloadButton?: boolean;
}
const OptionButtons: React.FC<OptionButtonProps> = ({ url, onFullscreenToggle, isFullscreen = false, toggleDownloadButton = true }) => {
  return (
  <MainContainer>
    {toggleDownloadButton && (
      <Container>
        <a href={url} download>
          <FiDownload />
        </a>
      </Container>
    )}
    <Container onClick={onFullscreenToggle}>
      {isFullscreen ? <RxExitFullScreen /> : <RxEnterFullScreen />}
    </Container>
  </MainContainer>
  );
}

const MainContainer = styled.div`

  align-self: flex-end;

  `
const Container = styled.div`
    padding:0.5vw;
    margin-left:0.5vw;
    margin-top:0.5vw;
    background-color: rgba(11, 26, 18, 1);
    border-radius: 3px;
    color:white;
    font-size: 1.5vw;
    width: 1.5vw;
    height: 1.5vw;
    display: flex;
    align-items: center;
    justify-content: center;
    a {
      text-align:center;
      display:flex;
      margin:auto;
      color:white;
    }
`;

export default OptionButtons